/**
* Content Pop Up JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Pop Up component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'content-pop-up',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.content-pop-up__splide' ).length ) {
        $( '.content-pop-up__splide' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            gap: '3rem',
            autoWidth: true,
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: 0.25,
            },
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-pop-up', COMPONENT );
} )( app );
